import {useEffect, useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { faFire } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next';
import bridgegap from '../img/bridgegap.png'
import HeaderHome from './layouts/HeaderHome';
import useWindowDimensions from './layouts/windowsDimensions';
import ayuda from '../img/ayuda.png';
const Main = ({setCuenta}) => {

    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const [pulseBtn, setPulseBtn] = useState(false);

    useEffect(() => {
        setTimeout(() => setVisible(true), 100);
        const interval = setInterval(() => {
            setPulseBtn(prev => !prev);
        }, 2000);
        return () => clearInterval(interval);
    }, []);

/******************************************************************************************* */

    // useEffect(() => {

    //     if(width >= 768){
    //         setdrops(true);
    //     }else{
    //         setdrops(false);
    //     }
    // }, [width])
    


/*******************************************************************************************/
    return (
    <>
     <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&family=Space+Mono:wght@400;700&display=swap');

        :root {
            --codaly-primary: #00C853;
            --codaly-dark: #f0fdf4;
            --codaly-card: #ffffff;
            --codaly-accent: #059669;
            --codaly-accent-light: #34d399;
            --codaly-glow: rgba(0, 200, 83, 0.18);
            --codaly-border: rgba(5, 150, 105, 0.15);
            --codaly-text: #0f172a;
            --codaly-muted: #475569;
        }

        .main-landing {
            font-family: 'Outfit', sans-serif;
            background: linear-gradient(160deg, #f0fdf4 0%, #ecfdf5 40%, #f8fafc 100%);
            min-height: 100vh;
            color: var(--codaly-text);
            overflow-x: hidden;
        }


        .main-landing * {
            box-sizing: border-box;
        }

        /* Animated background mesh */
        .bg-mesh {
            position: fixed;
            inset: 0;
            z-index: 0;
            background:
                radial-gradient(ellipse 80% 50% at 20% 40%, rgba(0, 200, 83, 0.12) 0%, transparent 60%),
                radial-gradient(ellipse 60% 40% at 80% 20%, rgba(52, 211, 153, 0.1) 0%, transparent 50%),
                radial-gradient(ellipse 50% 60% at 50% 90%, rgba(0, 200, 83, 0.07) 0%, transparent 50%);
            pointer-events: none;
        }

        .grid-overlay {
            position: fixed;
            inset: 0;
            z-index: 0;
            background-image:
                linear-gradient(rgba(5, 150, 105, 0.06) 1px, transparent 1px),
                linear-gradient(90deg, rgba(5, 150, 105, 0.06) 1px, transparent 1px);
            background-size: 60px 60px;
            pointer-events: none;
        }


        .content-wrapper {
            position: relative;
            z-index: 1;
        }

        /* Hero Section */
        .hero-section {
            min-height: 90vh;
            display: flex;
            align-items: center;
            padding: 6rem 0 4rem;
        }

        .hero-badge {
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            background: rgba(5, 150, 105, 0.08);
            border: 1px solid rgba(5, 150, 105, 0.2);
            color: #059669;
            border-radius: 100px;
            padding: 0.4rem 1.2rem;
            font-family: 'Space Mono', monospace;
            font-size: 0.75rem;
            letter-spacing: 0.08em;
            text-transform: uppercase;
            color: var(--codaly-accent);
            margin-bottom: 2rem;
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);
        }

        .hero-badge.show {
            opacity: 1;
            transform: translateY(0);
        }

        .hero-badge .dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: var(--codaly-accent);
            animation: blink 2s infinite;
        }

        @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.3; }
        }

        .hero-title {
            font-size: clamp(2.5rem, 6vw, 5rem);
            font-weight: 900;
            line-height: 1.05;
            letter-spacing: -0.03em;
            margin-bottom: 1.5rem;
            opacity: 0;
            transform: translateY(30px);
            transition: all 1s cubic-bezier(0.16, 1, 0.3, 1) 0.15s;
        }

        .hero-title.show {
            opacity: 1;
            transform: translateY(0);
        }

        .hero-title .highlight {
            background: linear-gradient(135deg, var(--codaly-primary), var(--codaly-accent));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }

        .hero-title .line-through {
            text-decoration: line-through;
            opacity: 0.3;
            font-weight: 400;
            font-size: 0.5em;
            vertical-align: middle;
        }

        .hero-subtitle {
            font-size: clamp(1rem, 2vw, 1.3rem);
            color: #475569;
            line-height: 1.7;
            max-width: 540px;
            margin-bottom: 2.5rem;
            opacity: 0;
            transform: translateY(30px);
            transition: all 1s cubic-bezier(0.16, 1, 0.3, 1) 0.3s;
        }

        .hero-subtitle.show {
            opacity: 1;
            transform: translateY(0);
        }

        .hero-actions {
            display: flex;
            gap: 1rem;
            flex-wrap: wrap;
            opacity: 0;
            transform: translateY(30px);
            transition: all 1s cubic-bezier(0.16, 1, 0.3, 1) 0.45s;
        }

        .hero-actions.show {
            opacity: 1;
            transform: translateY(0);
        }

        .btn-codaly {
            display: inline-flex;
            align-items: center;
            gap: 0.6rem;
            padding: 1rem 2rem;
            border-radius: 12px;
            font-family: 'Outfit', sans-serif;
            font-weight: 600;
            font-size: 1rem;
            text-decoration: none;
            border: none;
            cursor: pointer;
            transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
            position: relative;
            overflow: hidden;
        }

        .btn-codaly-primary {
            background: linear-gradient(135deg, #00C853, #00e676);
            color: #064e3b;
            box-shadow: 0 0 30px rgba(0, 200, 83, 0.25);
            font-weight: 700;
        }

        .btn-codaly-primary:hover {
            transform: translateY(-2px);
            box-shadow: 0 0 50px rgba(0, 200, 83, 0.4);
            color: #064e3b;
        }

        .btn-codaly-outline {
            background: transparent;
            color: var(--codaly-text);
            border: 1px solid var(--codaly-border);
        }

        .btn-codaly-outline:hover {
            background: rgba(52, 211, 153, 0.06);
            border-color: var(--codaly-accent);
            color: var(--codaly-accent);
            transform: translateY(-2px);
        }

        .btn-pulse {
            animation: btnPulse 2s ease-in-out infinite;
        }

        @keyframes btnPulse {
            0%, 100% { box-shadow: 0 0 30px rgba(0, 200, 83, 0.2); }
            50% { box-shadow: 0 0 50px rgba(0, 200, 83, 0.4); }
        }

        /* Visual side */
        .hero-visual {
            opacity: 0;
            transform: translateX(40px);
            transition: all 1.2s cubic-bezier(0.16, 1, 0.3, 1) 0.4s;
        }

        .hero-visual.show {
            opacity: 1;
            transform: translateX(0);
        }

        .visual-card {
            background: #ffffff;
            border: 1px solid rgba(5, 150, 105, 0.15);
            border-radius: 20px;
            padding: 2.5rem;
            position: relative;
            overflow: hidden;
            box-shadow: 0 8px 40px rgba(0, 200, 83, 0.1), 0 2px 12px rgba(0,0,0,0.06);
        }

        .feature-card {
            background: #ffffff;
            border: 1px solid rgba(5, 150, 105, 0.12);
            border-radius: 16px;
            padding: 2rem;
            height: 100%;
            transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
            position: relative;
            overflow: hidden;
            box-shadow: 0 2px 12px rgba(0,0,0,0.05);
        }

        .feature-card:hover {
            border-color: rgba(5, 150, 105, 0.35);
            transform: translateY(-4px);
            box-shadow: 0 20px 40px rgba(0, 200, 83, 0.15);
        }

        .visual-card::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 1px;
            background: linear-gradient(90deg, transparent, var(--codaly-accent), transparent);
            opacity: 0.5;
        }

        .barcode-animation {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 2rem;
            height: 160px;
        }

        .barcode-animation img {
            max-height: 100%;
            max-width: 100%;
            object-fit: contain;
            display: block;
            margin: auto;
        }


        .bar {
            width: 4px;
            background: var(--codaly-accent);
            border-radius: 2px;
            opacity: 0.6;
            animation: barGrow 1.5s ease-in-out infinite alternate;
        }

        @keyframes barGrow {
            from { transform: scaleY(0.3); opacity: 0.3; }
            to { transform: scaleY(1); opacity: 0.8; }
        }

        .feature-chips {
            display: flex;
            flex-wrap: wrap;
            gap: 0.5rem;
            justify-content: center;
        }

        .chip {
            font-family: 'Space Mono', monospace;
            font-size: 0.7rem;
            padding: 0.35rem 0.8rem;
            border-radius: 6px;
            background: rgba(52, 211, 153, 0.06);
            border: 1px solid var(--codaly-border);
            color: var(--codaly-muted);
            letter-spacing: 0.04em;
            width: 100%;
        }

        /* Migration Banner */
        .migration-banner {
            background: #ffffff;
            border: 1px solid rgba(5, 150, 105, 0.15);
            border-radius: 16px;
            padding: 2.5rem;
            margin-bottom: 4rem;
            position: relative;
            overflow: hidden;
            box-shadow: 0 4px 20px rgba(0, 200, 83, 0.08);
        }


        .migration-banner::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 2px;
            background: linear-gradient(90deg, transparent, var(--codaly-primary), transparent);
        }

        .arrow-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 48px;
            height: 48px;
            border-radius: 12px;
            background: rgba(52, 211, 153, 0.08);
            color: var(--codaly-accent);
            font-size: 1.4rem;
            flex-shrink: 0;
        }

        .old-name {
            font-family: 'Space Mono', monospace;
            text-decoration: line-through;
            color: var(--codaly-muted);
            opacity: 0.5;
        }

        .new-name {
            font-weight: 700;
            color: var(--codaly-accent);
        }

        /* Features */
        .features-section {
            padding: 4rem 0;
        }

        .section-label {
            font-family: 'Space Mono', monospace;
            font-size: 0.75rem;
            letter-spacing: 0.15em;
            text-transform: uppercase;
            color: var(--codaly-accent);
            margin-bottom: 1rem;
        }

        .section-title {
            font-size: clamp(1.8rem, 3.5vw, 2.8rem);
            font-weight: 800;
            letter-spacing: -0.02em;
            margin-bottom: 3rem;
        }

        .feature-card {
            background: var(--codaly-card);
            border: 1px solid var(--codaly-border);
            border-radius: 16px;
            padding: 2rem;
            height: 100%;
            transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
            position: relative;
            overflow: hidden;
        }

        .feature-card:hover {
            border-color: rgba(52, 211, 153, 0.3);
            transform: translateY(-4px);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
        }

        .feature-icon {
            width: 48px;
            height: 48px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.4rem;
            margin-bottom: 1.2rem;
            background: rgba(52, 211, 153, 0.08);
        }

        .feature-card h4 {
            font-weight: 700;
            font-size: 1.1rem;
            margin-bottom: 0.6rem;
        }

        .feature-card p {
            color: var(--codaly-muted);
            font-size: 0.9rem;
            line-height: 1.6;
            margin: 0;
        }

        /* CTA Section */
        .cta-section {
            padding: 5rem 0;
            text-align: center;
        }

        .cta-box {
            background: linear-gradient(135deg, rgba(0, 200, 83, 0.08), rgba(52, 211, 153, 0.04));
            border: 1px solid var(--codaly-border);
            border-radius: 24px;
            padding: 4rem 2rem;
            position: relative;
            overflow: hidden;
        }

        .cta-box::before {
            content: '';
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 200px;
            height: 1px;
            background: linear-gradient(90deg, transparent, var(--codaly-accent), transparent);
        }

        /* Footer */
        .landing-footer {
            border-top: 1px solid var(--codaly-border);
            padding: 2.5rem 0;
            color: var(--codaly-muted);
            font-size: 0.85rem;
        }

        .landing-footer a {
            color: var(--codaly-muted);
            text-decoration: none;
            transition: color 0.3s;
        }

        .landing-footer a:hover {
            color: var(--codaly-accent);
        }

        /* Responsive */
        @media (max-width: 767px) {
            .hero-section {
                min-height: auto;
                padding: 8rem 0 3rem;
            }
            .visual-card {
                padding: 1.5rem;
            }
            .migration-banner {
                padding: 1.5rem;
            }
            .cta-box {
                padding: 3rem 1.5rem;
            }
        }
    `}</style>
    <div className='principal'>
        
        <HeaderHome
            setCuenta={setCuenta}
        />

        <div style={{marginTop: '11rem', marginRight: '3rem', marginLeft: '3rem'}}>

            <div className="main-landing  rounded">
                <div className="bg-mesh"/>
                <div className="grid-overlay" />

                <div className="content-wrapper">

                    <div className="container">
                        {/* Hero */}
                        <section className="hero-section">
                            <div className="row align-items-center w-100">
                                <div className="col-lg-6 mb-5 mb-lg-0">

                                    <h1 className={`hero-title ${visible ? 'show' : ''}`}>
                                        <span className="line-through">web2 barcode</span><br />
                                        Evoluciona con{' '}
                                        <span className="highlight">Codaly</span>
                                    </h1>

                                    <p className={`hero-subtitle ${visible ? 'show' : ''}`}>
                                        Todo lo que conoces de impresión de etiquetas y código de barras, 
                                        ahora más rápido, más potente y con una experiencia completamente renovada.
                                    </p>

                                    <div className={`hero-actions ${visible ? 'show' : ''}`}>
                                        <a
                                            href="https://codaly.com.mx"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn-codaly btn-codaly-outline"
                                        >
                                            Conocer Codaly
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                <line x1="7" y1="17" x2="17" y2="7" />
                                                <polyline points="7 7 17 7 17 17" />
                                            </svg>
                                        </a>
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div>
                                        <div className="visual-card">
                                            <div className="barcode-animation">
                                                <a
                                                    href="https://codaly.com.mx"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                ><img
                                                    src={'https://labeldictate.com/wp-content/uploads/2025/07/codaly.png'}
                                                    alt="Codaly web"
                                                    style={{ maxWidth: '100%', maxHeight: '140px', objectFit: 'contain' }}                                                
                                                />
                                                </a>
                                            </div>
                                            <div className="text-center mb-3">
                                                <span style={{
                                                    fontFamily: "'Space Mono', monospace",
                                                    fontSize: '0.8rem',
                                                    color: 'var(--codaly-muted)',
                                                    letterSpacing: '0.3em'
                                                }}>
                                                    CODALY.COM.MX
                                                </span>
                                            </div>
                                            <div className="feature-chips text-center">
                                                <span className="chip">Impresión de etiquetas</span>
                                                <span className="chip">Web | IOS | Android</span>
                                                <span className="chip">Verificador de precios</span>
                                                <span className="chip">Actualización de precios en tiempo real</span>
                                                <span className="chip">Gestión de usuarios</span>
                                                <span className="chip">Diseñador de etiquetas</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                        {/* CTA */}
                        <section className="cta-section">
                            <div className="cta-box">
                                <h2 style={{
                                    fontSize: 'clamp(1.5rem, 3vw, 2.5rem)',
                                    fontWeight: 800,
                                    marginBottom: '1rem',
                                    letterSpacing: '-0.02em'
                                }}>
                                    ¿Listo para continuar?
                                </h2>
                                <p style={{
                                    color: 'var(--codaly-muted)',
                                    maxWidth: '500px',
                                    margin: '0 auto 2rem',
                                    fontSize: '1.05rem'
                                }}>
                                    <p>{'  '}Migra hoy mismo{'  '}</p>
                                    <p>{'  '}Más potente, mayor control y diseño de etiquetas personalizados{'  '}</p>
                                    <p>Descubre todo lo nuevo que Codaly tiene para ti.</p>
                                </p>
                                <div className="d-flex gap-3 justify-content-center flex-wrap">
                                    <a
                                        href="https://codaly.com.mx/designer"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn-codaly btn-codaly-primary"
                                    >
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                                            <polyline points="10 17 15 12 10 7" />
                                            <line x1="15" y1="12" x2="3" y2="12" />
                                        </svg>
                                        Diseñador de Codaly
                                    </a>
                                </div>
                            </div>
                        </section>

                        {/* Help */}
                        <section style={{ paddingBottom: '3rem' }}>
                            <div className="migration-banner" style={{ textAlign: 'center' }}>
                                <h3 style={{ fontWeight: 700, marginBottom: '0.5rem' }}>¿Necesitas ayuda?</h3>
                                <p style={{ color: 'var(--codaly-muted)', marginBottom: '1.5rem' }}>
                                    Nuestro centro de soporte está disponible para resolver cualquier duda.
                                </p>
                                <a
                                    href="https://ayuda.labeldictate.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn-codaly btn-codaly-outline"
                                >
                                    Centro de ayuda →
                                </a>
                            </div>
                        </section>
                    </div>

                    
                </div>
            </div>

        </div>

        <footer className="mt-auto py-4 bg-dark box-sh">
            <div className="container">
                <div className="d-flex justify-content-between">
                    <div className="text-white text-center w-100">
                        <p className="m-0">© Copyright <strong>Label Dictate Latam S.A. de C.V.</strong> Todos los derechos reservados.</p>
                        <p className="m-0 text-muted">Independencia 1018 I-201, Parques del Bosque, Tlaquepaque, Jalisco, México. 45609</p>
                        <span className="text-muted">
                            Diseñado por <a href="/" className="link-secondary">Label Dictate Latam S.A. de C.V</a> 
                        </span>
                        <p className="text-muted m-0">
                            <a href="https://labeldictate.com/?c=privacy" className="link-secondary">Privacy Policy</a> 
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    </div>
    </>
  )
}



export default Main